import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '../../utils/modules/core/modules/core-common.module';
import { WtfSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        WtfSearchBarComponent
    ],
    imports     : [
        CoreCommonModule,
        RouterModule
    ],
    exports     : [
        WtfSearchBarComponent
    ]
})
export class WtfSearchBarModule
{
}
